import { render } from "./LocationIndex.vue?vue&type=template&id=51ff0d82&scoped=true&ts=true"
import script from "./LocationIndex.vue?vue&type=script&lang=ts"
export * from "./LocationIndex.vue?vue&type=script&lang=ts"

import "./LocationIndex.vue?vue&type=style&index=0&id=51ff0d82&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ff0d82"]])

export default __exports__